import type { PaymentProduct } from '@/features/veluvit/schemas/payment.schema'

export function chargeRewards(product: PaymentProduct) {
  const bonus = product.bonus ?? 0
  const firstBonus = product.firstCharge?.eligible
    ? product.firstCharge.bonus
    : 0
  return { credits: product.credits, bonus, firstBonus }
}

export function chargeArt(tier: number) {
  return `/images/veluvit/shop/gem-pack-${Math.min(6, Math.max(1, tier))}-v2.webp`
}
